<template>
  <el-popover placement="bottom" :width="342" v-model="visible" :disabled="readonly" trigger="manual" ref="popover">
    <div slot="reference" v-if="onlyValue" :class="{'show-txt-rest':readonly,'blur-border': visible,'visible-onlyValue': currentData && currentData.length > 0}" class="table-select-box member-wrap-ReviewPrincipal" @click="visible = !visible">
      <div class="table-select-onlyValue" v-if="currentData && currentData.length > 0">
        <div class="avatar-parent-box" v-if="currentData && currentData.length > 0">
          <div class="avatar-parent-flex">
            <span class="reviewPrincipal-onlyValue" v-for="(item,index) in currentData" :key="index" >
              {{item}}
              <i v-if="!readonly && visible" class="icon iconfont iconicon_close1 del-icon" @click.stop="delItemTable(index)"></i>
            </span>
          </div>
        </div>
      </div>
      <p v-else class="table-select-button">
        <span v-if="readonly">-</span>
        <span v-else><i class="el-icon-circle-plus"></i>添加</span>
      </p>
    </div>
    <div v-else slot="reference" class="member-wrap-ReviewPrincipal" :class="{'show-txt-rest':readonly}" ref="reviewPrincipal"  @click="visible = !visible">
      <div v-if="currentData && currentData.length > 0" class="executor">
        <div
          class="reviewPrincipal"
          :class="{'readonly-item': readonly}"
          style="font-size: 14px;"
          v-for="(item,index) in currentData"
          :key="index"
        >
          <toolTip :title="item" :maxWidth="'160px'">{{item}}</toolTip>
          <i  v-if="!readonly" class="icon iconfont iconicon_close1 del-icon" @click.stop="delItem(index)"></i>
        </div>
      </div>
      <div v-else class="placeholder">
        <span class="add-txt">{{readonly ? '-' : '添加'}}</span>
      </div>
    </div>
    <PopupBox :checkedMember="currentData" :list="config.default_value_range" @empty="clearChekc" @change="memberChange" :visible="visible"></PopupBox>
  </el-popover>
</template>

<script>
import PopupBox from './popupBox.vue'
export default {
  components: {
    PopupBox
  },
  props: ['config', 'value', 'onlyValue', 'defaultValue', 'readonly', 'isTemplate'],
  data() {
    return {
      visible: false,
    }
  },
  computed: {
    currentData: {
      get() {
        return this.value || [];
      },
      set(newValue) {
        this.$emit('input', newValue || [])
      }
    },
  },
  mounted() {
    document.addEventListener("click", this.bodyCloseMenus);
    if(this.isTemplate) {
      // this.currentData = this.defaultValue || []
      if(this.defaultValue) {
        this.$emit("input", this.defaultValue)
        this.currentData = this.defaultValue
      } else if (this.config.default_values) {
        this.$emit('input', this.config.default_values)
        this.currentData = this.config.default_values
      }
    } else {
      let arrValue = this.getDefaultValue(this.defaultValue)
      this.currentData = arrValue
    }
  },
  beforeDestroy() {
     document.removeEventListener("click", this.bodyCloseMenus);
  },
  methods: {
    getMessage(res) {
      if (res.add_data.length > 0 && res.delete_data.length > 0) {
        return `<span class="message-mixin-tip">将${res.field_name || ''}修改为</span>
        <span class="message-mixin-task">${res.add_data.map(res => `[${res}]`).join('')}</span>,<span class="message-mixin-tip">${res.field_name}移除</span><span class="message-mixin-task">${res.add_data.map(res => `[${res}]`).join('')}</span>`
      } else if (res.add_data.length > 0) {
        return `<span class="message-mixin-tip">将${res.field_name || ''}修改为</span><span class="message-mixin-task">${res.add_data.map(res => `[${res}]`).join('')}</span>`
      } else if (res.delete_data.length > 0) {
        return `<span class="message-mixin-tip">将${res.field_name || ''}移除</span><span class="message-mixin-task">${res.delete_data.map(res => `[${res}]`).join('')}</span>`
      }
    },
    getDefaultValue(val) { // 兼容添加场景
      if (val && val.length > 0) {
        let arr = val.map(res => res.component_value).filter(res => res)
        return arr.length > 0 ? arr : val
      }
    },
    bodyCloseMenus(e) {
      if (this.$refs.popover.$el && !this.$refs.popover.$el.contains(e.target)) {
        if (this.visible == true) {
          this.visible = false
        }
      }
    },
    memberChange(data) {
      this.currentData = data
      this.$emit('change', data)
    },
    delItem(index) {
      this.delItemTable(index)
      this.visible = false
    },
    delItemTable(index) {
      this.currentData.splice(index, 1)
      this.$emit('change', this.currentData)
    },
    clearChekc() {
      this.$emit('input', [])
      this.$emit('change', [])
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
